var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { stringifyVariables } from '../../utils/stringifyVariables';
import { getNextDefaultBucket } from '../defaults';
import { addBucketIfRequired, } from '../types';
export var defaultDocumentOptions = {
    identifiedBy: function (data) {
        if (data && data.id) {
            return data.id;
        }
    },
    mapVarsToKey: function (vars) {
        if (typeof vars === 'number' || typeof vars === 'string') {
            return vars;
        }
        if (vars) {
            var varNames = Object.keys(vars);
            if (varNames.length === 1 && varNames[0] === 'id') {
                return vars[varNames[0]];
            }
            else if (varNames.length) {
                return stringifyVariables(vars);
            }
        }
    },
};
// ---
export function documentSchematic(bucketOrOptions, options) {
    if (bucketOrOptions === void 0) { bucketOrOptions = {}; }
    var bucket;
    if (!options) {
        options = bucketOrOptions;
        bucket = options.bucket || getNextDefaultBucket();
    }
    else {
        bucket = bucketOrOptions;
    }
    var _a = options.identifiedBy, identifiedBy = _a === void 0 ? defaultDocumentOptions.identifiedBy : _a, _b = options.mapVarsToId, mapVarsToId = _b === void 0 ? defaultDocumentOptions.mapVarsToKey : _b, transformInput = options.transformInput;
    return function (vars) {
        var selection;
        if (mapVarsToId) {
            var id = mapVarsToId(vars);
            if (id) {
                selection = { root: addBucketIfRequired(bucket, id) };
            }
        }
        return new DocumentSchematicImplementation(selection, vars, identifiedBy, bucket, transformInput);
    };
}
var DocumentSchematicImplementation = /** @class */ (function () {
    function DocumentSchematicImplementation(_selection, vars, identifiedBy, bucket, transformInput) {
        this._selection = _selection;
        this.vars = vars;
        this.identifiedBy = identifiedBy;
        this.bucket = bucket;
        this.transformInput = transformInput;
    }
    Object.defineProperty(DocumentSchematicImplementation.prototype, "selection", {
        get: function () {
            if (!this._selection) {
                throw new Error("Resource Error: couldn't identify resource from vars. Have you defined \"mapVarsToId\"?");
            }
            return this._selection;
        },
        enumerable: true,
        configurable: true
    });
    DocumentSchematicImplementation.prototype.chunk = function (input) {
        var data = this.transformInput
            ? this.transformInput(input, this.vars)
            : input;
        var id = this.identifiedBy(data, this.vars, input) ||
            (this._selection && this._selection.root);
        if (!id) {
            throw new Error("Resource Error: couldn't identify resource");
        }
        var root = addBucketIfRequired(this.bucket, id);
        var selection = { root: root };
        var chunks = [];
        var chunkData = data;
        chunks.push(__assign(__assign({}, root), { payload: {
                type: 'data',
                data: chunkData,
            } }));
        return { chunks: chunks, selection: selection };
    };
    DocumentSchematicImplementation.prototype.build = function (selection, pick) {
        var result = pick(selection.root);
        var unprimedResult = {
            pending: true,
            primed: false,
        };
        if (!result.primed) {
            return unprimedResult;
        }
        var invalidated = result.invalidated;
        var pending = result.pending;
        if (result.hasRejection) {
            return {
                hasRejection: true,
                invalidated: invalidated,
                pending: pending,
                primed: true,
                rejection: result.rejection,
            };
        }
        if (!result.hasData) {
            return {
                hasData: false,
                hasRejection: false,
                invalidated: false,
                pending: false,
                primed: true,
            };
        }
        return {
            hasData: true,
            invalidated: invalidated,
            pending: pending,
            primed: true,
            data: result.data,
        };
    };
    return DocumentSchematicImplementation;
}());
//# sourceMappingURL=documentSchematic.js.map